import { render } from "./name.vue?vue&type=template&id=aeb5b690"
import script from "./name.vue?vue&type=script&lang=js"
export * from "./name.vue?vue&type=script&lang=js"

import "./name.vue?vue&type=style&index=0&id=aeb5b690&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__